/**
 * FERP Workforce - Tenant ID Hook
 *
 * Extracts tenant ID from the authenticated user's JWT claim.
 * Single source of truth for tenant context in all repository operations.
 *
 * CONSTRAINTS:
 * - Tenant ID from JWT only (SINGLE SOURCE OF TRUTH)
 * - Returns null when unauthenticated
 */

import { useAuth } from '@ferp/auth';

export function useTenantId(): string | null {
  const { currentTenant } = useAuth();
  return currentTenant ?? null;
}

export default useTenantId;
